module.exports = __webpack_public_path__ + "static/media/coronavirus.37f2f4fc.svg";